import useEdgeQuery from '@app/data/edge/hooks/useEdgeQuery';
import { Tile } from '@app/types/generated';
import {
  GetTileCollectionQuery,
  GetTileCollectionQueryVariables,
} from '../queries/__generated__/getTileCollection.types';
import GET_TILE_COLLECTION from '../queries/getTileCollection';

type SelectReturn = {
  title: string;
  tiles?: Tile[];
};
const select = (data: GetTileCollectionQuery): SelectReturn => {
  if (!data) {
    return data;
  }

  return {
    title: data?.tileCollection?.title ?? '',
    tiles: data?.tileCollection?.tiles?.flatMap((item) => {
      if (!item) {
        return [];
      }

      return [item];
    }),
  };
};

type TileCollectionResponse = ReturnType<typeof select>;

const useTileCollection = (collection: string) =>
  useEdgeQuery<
    GetTileCollectionQuery,
    GetTileCollectionQueryVariables,
    TileCollectionResponse
  >(GET_TILE_COLLECTION, {
    variables: {
      collection,
    },
    select,
  });

export default useTileCollection;
